module.exports = __webpack_public_path__ + "wf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/wf.svg
// module id = 887
// module chunks = 0